import React from 'react'

import Layout from '../components/layout'
import Head from '../components/head'

import aboutStyles from '../styles/components/aboutPage.module.scss';

const aboutPage = () => {
    return (
        <Layout>
            <Head title="aboutMe"/>
            <section className = {aboutStyles.aboutMeContainer} id="About">
                <div className = {aboutStyles.aboutMeContent}>
                    <div className = {aboutStyles.aboutMeText}>
                        <h1>About Me</h1>
                        <div className={aboutStyles.aboutMeBlock}>
                            <div className = {aboutStyles.aboutImg2}></div>
                        </div>
                        <article>
                            <h3>Skills</h3>
                                <p><span>• ITSupport & System Administration </span></p>
                                    <p>• WebDevelopment & Service</p>
                                        <p><span>• FrontEnd: JavaScript, React, Vue</span></p>
                                            <p><span>• Bckend: Node, PHP </span></p>
                                            <p>• DataBases: MongoDB, MySQL</p>
                                            <p><span>• Virtual Environments</span></p>
                                            <p><span>• Linux</span></p>
                                            <p>• Languages: English B2, German A2</p>
                            <h3>Personal Interests</h3>
                                <p><span>• technology,</span> machines<span>, engines, </span>computers</p>
                                <p><span>• warlike games</span></p>
                                <p><span>• graphic modification, photography</span></p>
                                <p><span>• archeology</span></p>
                                <p><span>• travel and exploring foreign cusine</span></p>
                            <h3>Career Goals</h3>
                                <p><span>Seeking new opportunities as IT Support Specialist or IT Technician</span></p>
                                <p><span>I am open to on-site or remote job</span></p>
                            <h3>Closing Note</h3>
                            <p><span>Thanks visitors for exploring website.dc</span></p>
                        </article>
                        <div className={aboutStyles.imgAboutMeContainer}>
                            <img src='img/icons/thy.png' alt="thankyou.png"/>
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    )
}

export default aboutPage
